
import { CQAppConstant } from '../../../../../app-constants';
import { StandardHeaderAction } from '../action-controller/standard-header-action.controller';
import { CustomdHeaderAction } from '../action-controller/custom-header-action.controller';
import { StandardRowAction } from '../action-controller/standard-row-action.controller';
import { CustomRowAction } from '../action-controller/custom-row-action.controller';

export const ActionMapperController = {
    [CQAppConstant.ACTION_TYPES[0]]: {
        getControllerInstance: (actionObject: any) => {
            return new StandardHeaderAction(actionObject);
        }
    },
    [CQAppConstant.ACTION_TYPES[1]]: {
        getControllerInstance: (actionObject: any) => {
            return new CustomdHeaderAction(actionObject);
        }
    },
    [CQAppConstant.ACTION_TYPES[2]]: {
        getControllerInstance: (actionObject: any) => {
            return new StandardRowAction(actionObject);
        }
    },
    [CQAppConstant.ACTION_TYPES[3]]: {
        getControllerInstance: (actionObject: any) => {
            return new CustomRowAction(actionObject);
        }
    },
};
